// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"bf845b67","332":"087b416f","425":"a333283b","639":"865d338f"}[chunkId] + ".chunk.css";
};